<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Repeat Services</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column>
      <form v-on:keyup.enter="search">
        <v-checkbox @change="change" v-model="query.includeCancelled" label="Show Hidden"></v-checkbox>
        <v-btn
          @click="createRepeatService"
          color="blue"
          dark
          class="text-none"
        >Create Repeat Service</v-btn>
      </form>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "repeat_service_search_box",
  props: {
    query: Object
  },
  data: function() {
    return {};
  },
  methods: {
    createRepeatService: function() {
      this.$emit("createRepeatService", null);
    },
    change: function() {
      this.$emit("changeQuery", null);
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
